declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../src/app/ncs/models/api_response_model';
import { ApiRequestModel } from '../../../src/app/ncs/models/api_request_model';
import { SpinnerService } from '../../../src/app/ncs/services/spinner.service';
import { AppData } from '../../../src/app/ncs/models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NGXToastrService } from '../../../src/app/shared/services/toastr.service';
import * as alertFunctions from '../../../src/app/shared/data/sweet-alerts';

import sha1Hex from 'sha1-hex';

//import MD5 from 'src/app/shared/utils/md5';
import { UserAccountRequest } from '../../../src/app/ncs/models/login/useraccountrequest';
import { OTPToActivateAccount } from '../../../src/app/ncs/models/login/otptoactivateaccount';
import { UserActivationService } from '../../../src/app/ncs/services/useractivation.service';
import { TimeZoneMasterController, TimeZoneMasterRequest } from '../../../src/app/ncs/models/master/mastermodel';
import { MasterService } from '../../../src/app/ncs/services/master.service';



@Component({
  selector: 'signupreg',
  templateUrl: './signupreg.component.html',
  
  //styleUrls: ['./rncloudstartup.component.scss']
})

export class SignUpRegComponent implements OnInit {

  @ViewChild('f') registerForm: NgForm;
  @ViewChild('of') OTPForm: NgForm;
  public OTP: string = "";
  public ActivationRequestCode: number = 0;
  public ApiResData: ApiResponseModel;

  CurrentUserAccountRequest: UserAccountRequest;
  CurrentOTPToActivateAccount: OTPToActivateAccount;
  public UserAccountRequestStep: number = 0;
  public isRequesting: boolean = false;

  CurrentTimeZoneMasterController: TimeZoneMasterController[];
  CurrentTimeZoneMasterRequest: TimeZoneMasterRequest;



  constructor(private loaderService: SpinnerService,
    public UserActivationService: UserActivationService,
    private router: Router, private route: ActivatedRoute,
    private tosterservice: NGXToastrService, private modalService: NgbModal,
    private masterservice: MasterService) { }

  ngOnInit() {
    this.CurrentUserAccountRequest = new UserAccountRequest();
    this.CurrentOTPToActivateAccount = new OTPToActivateAccount();
    //this.CurrentUserAccountRequest.UserType = 3;
    this.GetTimeZoneMasterController();
  }
  onChangeTimeZone(Event: any) {

    this.CurrentUserAccountRequest.TimeZoneCode = parseInt(Event);

  }

  GetTimeZoneMasterController(): void {
    this.StartRefreshing();

    this.masterservice.GetTimeZoneMasterController(this.CurrentTimeZoneMasterRequest).subscribe
      (
      (result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTimeZoneMasterController = this.ApiResData.Result;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
      

      (error) => {

        if (error == "401 - Unauthorized") {

          this.stopRefreshing();



        }
        else {

          this.stopRefreshing();
        }
      }
      );;

  }
  onSubmit() {
    this.CurrentUserAccountRequest.TimeZoneCode = 31;
    this.CurrentUserAccountRequest.UserType = 13;
    if (this.CurrentUserAccountRequest.TimeZoneCode > 0) {
      this.StartRefreshing();

      //this.CurrentOTPToActivateAccount.ActorName = this.CurrentUserAccountRequest.ActorName;
      //this.CurrentOTPToActivateAccount.EmailID = this.CurrentUserAccountRequest.Email;
      //this.CurrentOTPToActivateAccount.MobileNo = this.CurrentUserAccountRequest.MobileNo;


      if (AppData.IsEncriptFromClientSide == true) {
        this.CurrentUserAccountRequest.Password =(this.CurrentUserAccountRequest.Password);

        this.CurrentUserAccountRequest.IsEncriptFromClient = true;
      }
      this.CurrentUserAccountRequest.Email = this.CurrentUserAccountRequest.UserName;
      
      this.UserActivationService.SaveUserAccountRequest(this.CurrentUserAccountRequest)
        .subscribe((result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {
            // alertFunctions.AlertParam('UserAccount Request Successfully...');
            //  alertFunctions.ShowSuccess('Activate Your Account', 'An activation code is sent to your registered Email ID, please check.');
            this.tosterservice.ToasterSuccessAlertParam('Activate Your Account', 'An activation code is sent to your registered Email ID, please check.');


            this.ActivationRequestCode = this.ApiResData.Result;
            
            this.CurrentOTPToActivateAccount.UserAccountRequestCode = parseInt(this.ApiResData.Result);
           
            //  console.log('this.CurrentOTPToActivateAccount.UserAccountRequestCode-->' + this.CurrentOTPToActivateAccount.UserAccountRequestCode)

            this.CurrentOTPToActivateAccount.ActorName = this.CurrentUserAccountRequest.ActorName;
            this.CurrentOTPToActivateAccount.EmailID = this.CurrentUserAccountRequest.Email;
            this.CurrentOTPToActivateAccount.MobileNo = this.CurrentUserAccountRequest.MobileNo;
            this.CurrentOTPToActivateAccount.UserName = this.CurrentUserAccountRequest.UserName;

            this.UserAccountRequestStep = 1;
            this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            this.CurrentUserAccountRequest.Password = "";
            if (this.ApiResData.ErrorData != "") {

              alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            }
            else {
              // alertFunctions.AlertParam('Registration Fail Due to Internal Error.... Please Contact Admin..');
              alertFunctions.AlertParamEr('Operation Failed Due to Internal Error.... Please Contact Admin..');
            }
          }

        },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


        );
    }
    else {
      alertFunctions.AlertParamEr("Please Check Input Values.");
    }
  }

  public ACTCODE: string;
  public onOTPSubmit() {
    // console.log('Save SucessFully...' + this.CurrentOTPToActivateAccount.ActivationCode);
   
    this.CurrentOTPToActivateAccount.ActivationCode = this.ACTCODE;
   
    ///this.CurrentOTPToActivateAccount.ActivationCode ="1";
    this.StartRefreshing();

    this.UserActivationService.xConfirmOTPWithActivateAccount(this.CurrentOTPToActivateAccount)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.activeModal.close();
            // alertFunctions.AlertParam('Account Activate Successfully...');
            alertFunctions.ShowSuccess('Account Activated', 'Your account is activated successfully, you may login with your credentials to continue.');
            this.router.navigate(['signinpage']);

            this.stopRefreshing();
          } else {
            this.stopRefreshing();
            // alertFunctions.AlertParamEr('Invalid Activation Code, please verify.');
            alertFunctions.AlertParamEr('Invalid Activation Code, please verify.');
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }

        }


      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );
  }

  public onResendOTP() {
    this.StartRefreshing();

    this.UserActivationService.xReSendOTPToActivateAccount(this.CurrentOTPToActivateAccount)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            // alertFunctions.ShowSuccess('Transaction Password Sent', 'A transaction password is resent to your registered Email ID');

            this.tosterservice.ToasterSuccessAlertParam('Transaction Password Sent', 'A transaction password is resent to your registered Email ID');


            //this.router.navigate(['signinpage']);

            this.stopRefreshing();
          } else {
            this.stopRefreshing();
            // alertFunctions.AlertParam('InCorrect OTP Request ');
            alertFunctions.AlertParamEr('Invalid Activation Code');
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            if (this.ApiResData.hasRedirectPage) {
              this.UserAccountRequestStep = 0;

            }
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }

        }


      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false); // disable spinner
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }




}
